import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import GitHubIcon from "@mui/icons-material/GitHub";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

function FooterNav(props) {
  return (
    <div>
      <nav>
        <ul>
          <a href="https://www.linkedin.com/in/codingbagh/" rel="noreferrer"  target="_blank">
            <LinkedInIcon />
          </a>
          <a href="https://www.instagram.com/codingbagh/" rel="noreferrer"  target="_blank">
            <InstagramIcon />
          </a>
          <a href="https://github.com/codingbagh" rel="noreferrer"  target="_blank">
            <GitHubIcon />
          </a>
          <a href="https://web.facebook.com/codingbagh" rel="noreferrer"  target="_blank">
            <FacebookIcon />
          </a>
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UCrmMlPdejsSUSmQGEy6Xrsw" rel="noreferrer" 
          >
            <YouTubeIcon />
          </a>
        </ul>
      </nav>

      <section className="sidebar">
        <a href="https://www.linkedin.com/in/codingbagh/" target="_blank" rel="noreferrer" >
          <LinkedInIcon />
        </a>
        <a href="https://www.instagram.com/codingbagh/" target="_blank" rel="noreferrer" >
          <InstagramIcon />
        </a>
        <a href="https://github.com/codingbagh" target="_blank" rel="noreferrer" >
          <GitHubIcon />
        </a>
        <a href="https://web.facebook.com/codingbagh" target="_blank" rel="noreferrer" >
          <FacebookIcon />
        </a>
        <a rel="noreferrer" 
          target="_blank"
          href="https://www.youtube.com/channel/UCrmMlPdejsSUSmQGEy6Xrsw"
        >
          <YouTubeIcon />
        </a>

        <a target="_blank" href="mailto:codingbakelvin@gmail.com" rel="noreferrer" >
          <MailOutlineIcon id="im" />
        </a>
      </section>
    </div>
  );
}

export default FooterNav;
